import { createSelector } from 'reselect';
import { RootState } from 'store/types';

// EVisit Session
export const eVisitSessionSelector = (state: RootState) => state.eVisit.session;
export const eVisitSessionFetchingSelector = createSelector(
  eVisitSessionSelector,
  eVisit => eVisit.isFetching
);
export const eVisitSessionErrorSelector = createSelector(
  eVisitSessionSelector,
  eVisit => eVisit.error
);
export const eVisitSessionTokenSelector = createSelector(
  eVisitSessionSelector,
  eVisit => eVisit.eVisitSessionToken
);
export const eVisitSessionStateSelector = createSelector(
  eVisitSessionSelector,
  eVisit => eVisit.eVisitState
);

// EVisit Eligibility
export const eVisitEligibilitySelector = (state: RootState) => state.eVisit.eligibility;
export const eVisitEligibilityRequestStateSelector = createSelector(
  eVisitEligibilitySelector,
  eligibility => eligibility?.requestState
);
export const eVisitEligibilityAccessSelector = createSelector(
  eVisitEligibilitySelector,
  eligibility => eligibility?.data?.access
);
export const eVisitEligibilityFetchingSelector = createSelector(
  eVisitEligibilitySelector,
  eligibility => eligibility?.isFetching
);

// EVisit appSettings SLA
export const eVisitSLASelector = (state: RootState) => state.appSettings.shared.evisit.sla;
